$('input[name=flavor1]').change(function() {
    jQuery(".button-price").html(jQuery(".current_price .money").html());
    // change the page per this logic
    switch ($('input[name=flavor1]:checked').val()) {
        case 'Cinnamon':
            $(this).closest('.single_product').find('.sub_title').text('Cinnamon Almond Pecan');
            $(this).closest('.single_product').find('.image_container').find('img').attr("srcset", "//cdn.shopify.com/s/files/1/0521/1435/8424/files/CinnamonGranola.jpg");
            $(this).closest('.single_product').find('.price').text("starting at $1.30 per serving");
            $(this).closest('.single_product').find('.product_url').attr("href", "/products/granolo-keto-granola?variant=39367784235160");

            break;
        case 'Chocolate':
            $(this).closest('.single_product').find('.sub_title').text('Chocolate Hazelnut')
            $(this).closest('.single_product').find('.image_container').find('img').attr("srcset", "//cdn.shopify.com/s/files/1/0521/1435/8424/files/Granolahazelnut.jpg");
            $(this).closest('.single_product').find('.price').text("starting at $1.30 per serving");
            $(this).closest('.single_product').find('.product_url').attr("href", "/products/granolo-keto-granola?variant=39367784169624");
            break;
        case 'Blueberry':
            $(this).closest('.single_product').find('.sub_title').text('Frosted Blueberry');
            $(this).closest('.single_product').find('.image_container').find('img').attr("srcset", "//cdn.shopify.com/s/files/1/0521/1435/8424/files/BluberryGranol.jpg");
            $(this).closest('.single_product').find('.price').text("starting at $1.30 per serving");
            $(this).closest('.single_product').find('.product_url').attr("href", "/products/granolo-keto-granola?variant=39367784202392");
            break;
        case 'VarietyPack':
            $(this).closest('.single_product').find('.sub_title').text('Variety Pack');
            $(this).closest('.single_product').find('.image_container').find('img').attr("srcset", "//cdn.shopify.com/s/files/1/0521/1435/8424/files/Livlo_Granolo_5000x.jpg");
            $(this).closest('.single_product').find('.price').text("starting at $1.30 per serving");
            $(this).closest('.single_product').find('.product_url').attr("href", "/products/granolo-keto-granola?variant=39473221664920");
            break;

            // case 'Bread':
            //     $(this).closest('.single_product').find('.sub_title').text('Bread');
            //     $(this).closest('.single_product').find('.image_container').find('img').attr("srcset", "//cdn.shopify.com/s/files/1/0521/1435/8424/files/product_1_1600x.jpg");
            //     break;
            // case 'Biscuits':
            //     $(this).closest('.single_product').find('.sub_title').text('Biscuits');
            //     $(this).closest('.single_product').find('.image_container').find('img').attr("srcset", "//cdn.shopify.com/s/files/1/0521/1435/8424/files/product_2_1600x.jpg");
            //     break;
    }
});


//run 10% code on product button on quantity change
$('.control').on("click", function() {
    var $this = $(this);
    var quantityInputBefore = $this.parent().find("input");
    setTimeout(function() {
        var quantityInput = $this.parent().find("input");
        if (quantityInput != quantityInputBefore) {
            var productData = jQuery(".product_form").data("product");
            var variantID = $("select[name='id']").val();
            if (productData.hasOwnProperty("variants") && productData.variants.length > 1) {
                for (var i = 0; i < productData.variants.length; i++) {
                    if (productData.variants[i].id == variantID) {
                        var granolaVariantsIncluded = [39367784235160, 39367784169624, 39367784202392];
                        var finalPriceForQuantity = productData.variants[i].price * quantityInput.val();
                        if ((jQuery(".product_form").data("product").tags.length > 0 && jQuery(".product_form").data("product").tags.includes("10on3ormore") && quantityInput.val() >= 3) || (granolaVariantsIncluded.includes(parseInt(variantID)) && quantityInput.val() >= 3)) {
                            var afterDiscount = '.10';
                            var num = parseFloat(finalPriceForQuantity);
                            var discountedPrice = finalPriceForQuantity - (finalPriceForQuantity * parseFloat(afterDiscount));
                            //console.log(val);
                            $(".button-price").html(Shopify.formatMoney(discountedPrice, $('body').data('money-format')));
                        } else {
                            $(".button-price").html(Shopify.formatMoney(finalPriceForQuantity, $('body').data('money-format')));
                        }
                    }
                }
            } else {
                var finalPriceForQuantity = productData.price * quantityInput.val();
                if (jQuery(".product_form").data("product").tags.length > 0 && jQuery(".product_form").data("product").tags.includes("10on3ormore") && quantityInput.val() >= 3) {
                    var afterDiscount = '.10';
                    var num = parseFloat(finalPriceForQuantity);
                    var discountedPrice = finalPriceForQuantity - (finalPriceForQuantity * parseFloat(afterDiscount));
                    //console.log(val);
                    $(".button-price-novar").html(Shopify.formatMoney(discountedPrice, $('body').data('money-format')));
                } else {
                    $(".button-price-novar").html(Shopify.formatMoney(finalPriceForQuantity, $('body').data('money-format')));
                }
            }
        }

    }, 500);
});



$('input[name=flavor2]').change(function() {
    // change the page per this logic
    switch ($('input[name=flavor2]:checked').val()) {
        case 'Brownies':
            $(this).closest('.single_product').find('.sub_title').text('Brownie Mix')
            $(this).closest('.single_product').find('.image_container').find('img').attr("srcset", "//cdn.shopify.com/s/files/1/0521/1435/8424/files/LivloBrownie.jpg");
            $(this).closest('.single_product').find('.price').text("starting at $0.75 per serving");
            $(this).closest('.single_product').find('.product_url').attr("href", "/products/keto-brownie-mix");
            break;
            // case 'Cinnamon':
            //     $(this).closest('.single_product').find('.sub_title').text('cinnamon almond pecan');
            //     $(this).closest('.single_product').find('.image_container').find('img').attr("srcset", "//cdn.shopify.com/s/files/1/0521/1435/8424/files/product_1_1600x.jpg");
            //     break;
            // case 'Blueberry':
            //     $(this).closest('.single_product').find('.sub_title').text('Blueberry');
            //     $(this).closest('.single_product').find('.image_container').find('img').attr("srcset", "//cdn.shopify.com/s/files/1/0521/1435/8424/files/product_2_1600x.jpg");
            //     break;
        case 'Bread':
            $(this).closest('.single_product').find('.sub_title').text('Bread Mix');
            $(this).closest('.single_product').find('.image_container').find('img').attr("srcset", "//cdn.shopify.com/s/files/1/0521/1435/8424/files/LivloBread.jpg");
            $(this).closest('.single_product').find('.price').text("starting at $0.88 per serving");
            $(this).closest('.single_product').find('.product_url').attr("href", "/products/bread-mix");
            break;
        case 'Biscuits':
            $(this).closest('.single_product').find('.sub_title').text('Biscuit Mix');
            $(this).closest('.single_product').find('.image_container').find('img').attr("srcset", "//cdn.shopify.com/s/files/1/0521/1435/8424/files/LivloBiscuit.jpg");
            $(this).closest('.single_product').find('.price').text("starting at $0.75 per serving");
            $(this).closest('.single_product').find('.product_url').attr("href", "/products/biscuit-mix");
            break;
        case 'VarietyPack':
            $(this).closest('.single_product').find('.sub_title').text('Variety Pack');
            $(this).closest('.single_product').find('.image_container').find('img').attr("srcset", "//cdn.shopify.com/s/files/1/0521/1435/8424/files/Livlo_Baking_5000x.jpg");
            $(this).closest('.single_product').find('.price').text("starting at $0.75 per serving");
            $(this).closest('.single_product').find('.product_url').attr("href", "/products/variety-pack-backing-mix");
            break;
    }

    document.querySelector('video').defaultPlaybackRate = 0.5;
    document.querySelector('video').play();

});


//stagePadding: 30, and margin 0
$('.review_carousel').owlCarousel({
    loop: true,
    mouseDrag: false,
    stagePadding: 0,
    margin: 10,
    responsiveClass: true,
    dots: false,
    nav: true,
    navText: ['<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>', '<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>'],
    responsive: {
        0: {
            items: 1
        },
        767: {
            items: 3
        },
        1000: {
            items: 4
        }
    }
});
$('.product_custom_carousel').owlCarousel({
    loop: true,
    mouseDrag: false,
    stagePadding: 0,
    margin: 10,
    responsiveClass: true,
    dots: false,
    nav: true,
    navText: ['<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>', '<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>'],
    responsive: {
        0: {
            items: 1
        },
        400: {
            items: 2
        },
        767: {
            items: 3
        },
        1000: {
            items: 4
        }
    }
});


$(window).on('load', function() {
    var sliderDiv = ".products-slider";
    $(sliderDiv).flickity({
        lazyLoad: 2,
        freeScroll: true,
        imagesLoaded: true,
        draggable: false,
        cellAlign: 'center',
        pageDots: false,
        contain: true,
        prevNextButtons: true,
        initialIndex: 0,
        on: {
            ready: function ready() {
                // Resize flickity when the slider is settled
                $(sliderDiv).on('settle.flickity', function() {
                    $(sliderDiv).flickity('resize');
                });
            }
        }
    });

    $('.swatch_options input').on('change', function(e) {

        var offer = $('.purchase_offer');
        console.log(e.target.checked);

        console.log($('.flavor-select').text())
        if ($(e.target).hasClass('swatch--variety-pack') && e.target.checked) {
            offer.hide();
            console.log('yes')
        } else {
            offer.show();
            console.log('no')
        }

    });
});



window.dispatchEvent(new Event('resize'));